var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { delay, put } from 'redux-saga/effects';
import { runGenerator, actionTypeMatches, alwaysFalse } from './utils';
import { exponentialGrowth } from './backoff';
export function retry(saga, options) {
    var _a = options || {}, _b = _a.backoff, backoff = _b === void 0 ? exponentialGrowth : _b, _c = _a.debug, debug = _c === void 0 ? false : _c, _d = _a.retries, retries = _d === void 0 ? 3 : _d, _e = _a.condition, condition = _e === void 0 ? /_FAILURE$/ : _e;
    var conditionFn = condition instanceof RegExp ? actionTypeMatches(condition) : condition;
    /* eslint-disable-next-line consistent-return */
    function retryableGenerator() {
        var _i, action, maxRetries, i, conditionToUse, e_1;
        var _a;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    action = args[args.length - 1];
                    maxRetries = ((_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.retries) || retries;
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i <= maxRetries)) return [3 /*break*/, 9];
                    conditionToUse = i === maxRetries ? alwaysFalse : conditionFn;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [5 /*yield**/, __values(runGenerator(saga.apply(void 0, __spread(args)), conditionToUse))];
                case 3: return [2 /*return*/, _b.sent()];
                case 4:
                    e_1 = _b.sent();
                    if ((e_1 === null || e_1 === void 0 ? void 0 : e_1.message) !== 'RetryError') {
                        throw e_1;
                    }
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, delay(backoff(i))];
                case 6:
                    _b.sent();
                    if (!debug) return [3 /*break*/, 8];
                    return [4 /*yield*/, put({
                            type: '@@REDUX-SAGA-RETRY',
                            payload: {
                                action: action.type,
                                attempt: i + 1,
                            },
                        })];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    i += 1;
                    return [3 /*break*/, 1];
                case 9: return [2 /*return*/];
            }
        });
    }
    Object.defineProperty(retryableGenerator, 'name', { value: "retryGenerator(" + saga.name + ")" });
    return retryableGenerator;
}
//# sourceMappingURL=retry.js.map